import React, { useCallback, useState } from 'react';
import { ListItemButton, ListItemIcon, ListItemText} from '@mui/material';
import ExcelJS from 'exceljs';
import moment from 'moment/moment';
import { convert } from 'html-to-text';
import api from '../../../services/api';
import { LoadingButton } from '@mui/lab';
import CloudDownloadRoundedIcon from "@mui/icons-material/CloudDownloadRounded";

export const GuideSchedule = ({values, listItem = false}) => {
  const [loading, setLoading] = useState(false);

  const generateSchedule = useCallback(() => {
    setLoading(true);

    api.get(`/groups/${values?.id}/reservations`).then((res) => {
      exportGuideSchedule(res);
    });

    setLoading(false);
  }, [values]);

  const exportGuideSchedule = (group) => {
    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet('Guide Schedule');

    sheet.pageSetup = {
      orientation: 'landscape',
      paperSize: 9,
    };
    sheet.pageSetup.fitToPage = true;

    sheet.pageSetup.margins = {
      left: 0.2,
      right: 0.2,
      top: 0.5,
      bottom: 0.5,
      header: 0.5,
      footer: 0.5,
    };

    sheet.pageSetup.printArea = 'A:O';

    // 147 max
    sheet.columns = [
      {
        header: '',
        key: 'row_number',
        width: 3,
      },{
        header: 'Activity',
        key: 'activity',
        width: 23,
      },
      {
        header: 'Guide',
        key: 'guide',
        width: 13,
      },
      {
        header: 'Provider',
        key: 'service_provider',
        width: 11,
      },
      {
        header: 'Size',
        key: 'group_size',
        width: 4,
      },
      {
        header: 'Date',
        key: 'date',
        width: 8,
      },
      {
        header: 'Pickup',
        key: 'pickup_time',
        width: 8,
      },
      {
        header: 'Pickup From',
        key: 'address_from',
        width: 18,
      },
      {
        header: 'Activity Start',
        key: 'start_time',
        width: 12,
      },
      {
        header: 'Location',
        key: 'address_to',
        width: 18,
      },
      {
        header: 'Staff',
        key: 'staff',
        width: 18,
      },
      {
        header: 'Driver',
        key: 'driver',
        width: 18,
      },
      {
        header: 'Transfer',
        key: 'transfer',
        width: 18,
      },
      {
        header: 'Vehicle',
        key: 'vehicle',
        width: 18,
      },
      {
        header: 'Notes',
        key: 'notes',
        width: 18,
      },
    ];

    const promise = Promise.all(
      group.activity_reservations?.map(async (item, index) => {
        const rowNumber = index + 1;

        let drivers =[];


        if (item?.drivers){
          item?.drivers.map((driver)=>{
            let name = driver?.name ? driver?.name : '-';
            if (driver?.phone){
              name = `${name} (${driver?.phone})`;
            }
            drivers.push(name);
          });
        }

        let activityWhere = item.address_to?.name ? item.address_to?.name : '';
        if (item.address_to?.address_line1){
          if (activityWhere === ''){
            activityWhere = item?.address_to?.address_line1;
          }else{
            activityWhere = `${activityWhere} (${item?.address_to?.address_line1})`;
          }

        }
        let pickupFrom = item.address_from?.name ? item.address_from?.name : '';
        if (item.address_from?.address_line1){
          if (pickupFrom === ''){
            pickupFrom = item?.address_from?.address_line1;
          }else{
            pickupFrom = `${pickupFrom} (${item?.address_from?.address_line1})`;
          }

        }

        sheet.addRow(
          {
            row_number: rowNumber,
            activity: item?.activity?.name,
            service_provider: item?.activity_providers,
            group_size: item.group_size,
            guide: item.guides,
            date: item.date ? moment(item.date).format('YYYY-MM-DD ddd') : '',
            meeting_time: item?.meeting_time ? item?.meeting_time : '',
            pickup_time: item?.pickup_time ? item?.pickup_time : '',
            start_time: item?.start_time ? item?.start_time : '',
            address_from: pickupFrom,
            address_to: activityWhere,
            staff: item?.staff_names,
            driver: drivers.join(','),
            transfer: item?.transfer_providers,
            vehicle: item.vehicle?.name,
            notes: convert(item.guide_notes),
          },
          ''
        );
      })
    );
    const defaultSize = 9;

    const getName = (obj) => {
      return obj.name;
    };

    const createOuterBorder = (
      worksheet,
      start = { row: 1, col: 1 },
      end = { row: 1, col: 1 },
      isTable = false
    ) => {
      for (let i = start.col; i <= end.col; i++) {
        worksheet.getCell(start.row, i).fill = {
          type: 'pattern',
          color: { argb: 'D9D9D9' },
        };

        for (let j = start.row; j <= end.row; j++) {
          worksheet.getCell(j, i).border = {
            top: { style: 'thin', color: { argb: '0000002B' } },
            left: { style: 'thin', color: { argb: '0000002B' } },
            bottom: { style: 'thin', color: { argb: '0000002B' } },
            right: { style: 'thin', color: { argb: '0000002B' } },
          };

          worksheet.getCell(j, i).font = {
            size: defaultSize,
          };

          worksheet.getCell(j, i).alignment = {
            wrapText: true,
            vertical: 'top',
            horizontal: 'left',
          };
        }
      }

      if (isTable) {
        for (let i = start.col; i <= end.col; i++) {
          const topBorderCell = worksheet.getCell(start.row, i);
          topBorderCell.font = {
            name: 'Roboto',
            family: 4,
            size: defaultSize,
            bold: true,
          };

          topBorderCell.alignment = {
            vertical: 'center',
            horizontal: 'center',
          };
        }
      }
    };

    createOuterBorder(
      sheet,
      { row: 1, col: 2 },
      { row: sheet.rowCount, col: sheet.columnCount },
      true
    );

    sheet.spliceRows(1, 0, []);
    sheet.spliceRows(1, 0, []);

    /* Group Info */
    sheet.spliceRows(1, 0, []);

    sheet.spliceRows(1, 0, []);
    sheet.spliceRows(1, 0, []);
    sheet.spliceRows(1, 0, []);
    sheet.spliceRows(1, 0, []);
    sheet.spliceRows(1, 0, []);

    // Empty line
    sheet.spliceRows(1, 0, []);

    /* Accommodation info */
    sheet.spliceRows(1, 0, []);

    sheet.spliceRows(1, 0, []);
    sheet.spliceRows(1, 0, []);
    sheet.spliceRows(1, 0, []);
    sheet.spliceRows(1, 0, []);
    sheet.spliceRows(1, 0, []);

    // Empty line
    sheet.spliceRows(1, 0, []);

    /* Flight info */
    sheet.spliceRows(1, 0, []);

    sheet.spliceRows(1, 0, []);
    sheet.spliceRows(1, 0, []);

    // Empty line
    sheet.spliceRows(1, 0, []);

    const accommodations = group?.bookings;
    /*accommodations.map((acc, index) => {
      sheet.spliceRows(1, 0, []);
    });*/
    sheet.spliceRows(1, 0, []);

    sheet.getCell('B1').value = `GUIDE SCHEDULE`;
    sheet.getCell('B2').value = '';

    /* Group info */

    sheet.getCell('B3').value = 'Group Info';

    sheet.mergeCells('B1:C1');
    sheet.mergeCells('B2:C2');
    sheet.mergeCells('B3:C3');

    const estTimeArr = group?.arrival_estimated_time ? group?.arrival_estimated_time :'';
    const estTimeDep = group?.departure_estimated_time ? group?.departure_estimated_time :'';

    sheet.getCell('B4').value = `GROUP: ${group?.name ? (`${group?.name}(${group?.phone?group?.phone:'-'})`) : '-'}`;
    sheet.getCell('B5').value = `Arrival: ${group?.arrival_date ? `${moment(group?.arrival_date).format('YYYY-MM-DD (ddd)')} ${estTimeArr}` : '-'}`;
    sheet.getCell('B6').value = `Group size: ${group?.size ? group?.size : '-'}`;
    sheet.getCell('B7').value = `Sales Partner Hotline: ${group?.sales_partner?.hotline ? group?.sales_partner?.hotline : '-'}`;
    sheet.getCell('B8').value = `Booking Manager Name - Partner: ${group?.sales_agent?.name ? group?.sales_agent?.name : '-'}`;

    for (let i=4; i<9; i++){
      sheet.mergeCells(`B${i}:C${i}`);
    }

    sheet.getCell('D4').value = `Stag name: ${group?.stag_name ? group?.stag_name : '-'}`;
    sheet.getCell('D5').value = `Departure: ${group?.departure_date ?`${moment(group?.departure_date).format('YYYY-MM-DD (ddd)')} ${estTimeDep}` : '-'}`;
    sheet.getCell('D6').value = `Sales partner: ${group?.sales_partner?.name ? group?.sales_partner?.name : '-'}`;
    sheet.getCell('D7').value = '';
    sheet.getCell('D8').value = `Booking Manager Name - Travel City: ${group?.booking_agent?.name ? group?.booking_agent?.name : '-'}`;

    for (let i=4; i<9; i++){
      sheet.mergeCells(`D${i}:H${i}`);
    }

    sheet.getCell('I4').value = `Country: ${group?.country ? group?.country : '-'}`;
    sheet.getCell('I5').value = `Language: ${group?.language?.name ? group?.language?.name : '-'}`;

    for (let i=4; i<9; i++){
      sheet.mergeCells(`I${i}:K${i}`);
    }

    sheet.getCell('B9').value = '';

    /* Accommodation info */

    sheet.mergeCells(`B10:C10`);
    sheet.getCell('B10').value = 'Accommodation Info';

    const accom = accommodations?.[0] ? accommodations[0]: null;
    let differenceInDays = '-';
    if (accom?.arrival && accom?.departure){
      const differenceInTime = new Date(accom?.departure) - new Date(accom?.arrival);
      differenceInDays = `${differenceInTime / (1000 * 60 * 60 * 24)} nights`;
    }

    sheet.getCell('B11').value = `Accommodation: ${accom?.accommodation?.name ? accom?.accommodation?.name : '-'}`;
    sheet.getCell('B12').value = `Checkin: ${accom?.checkin_time ? moment(accom?.checkin_time).format('HH:mm') : '-'}`;
    sheet.getCell('B13').value = `Accommodation Hotline: ${accom?.accommodation?.hotline ? accom?.accommodation?.hotline : '-'}`;
    sheet.getCell('B14').value = `Accommodation Booked: ${differenceInDays}`;
    sheet.getCell('B15').value = `Apartment allocation: `;

    for (let i=11; i<16; i++){
      sheet.mergeCells(`B${i}:C${i}`);
    }

    const addresses = accom?.accommodation?.addresses.map((addr)=>{
      let name = '';
      if (addr?.name){
        name = addr?.name;
        if (addr?.address_line1){
          name = `${name} (${addr?.address_line1})`;
        }
      }else{
        name = addr?.address_line1;
      }

      return name;
    });

    sheet.getCell('D11').value = `Accommodation address: ${addresses?addresses.join(','):'-'}`;
    sheet.getCell('D12').value = `Checkout: ${accom?.checkout_time ? moment(accom?.checkout_time).format('HH:mm') : '-'}`;
    sheet.getCell('D13').value = ``;
    sheet.getCell('D14').value = `From: ${accom?.arrival ? moment(accom?.arrival).format('YYYY-MM-DD ddd') : '-'}`;

    for (let i=11; i<14; i++){
      sheet.mergeCells(`D${i}:H${i}`);
    }

    sheet.mergeCells(`D14:E14`);
    sheet.mergeCells(`F14:H14`);

    sheet.getCell('F14').value = `To: ${accom?.departure ? moment(accom?.departure).format('YYYY-MM-DD ddd') : '-'}`;

    for (let i=15; i<16; i++){
      sheet.mergeCells(`D${i}:H${i}`);
    }

    sheet.getCell('I11').value = `Booked By: ${accom?.booked_by?.name ? accom?.booked_by?.name : '-'}`;
    sheet.getCell('I12').value = `Accommodation needs IDs from group: yes / no`;
    sheet.getCell('I13').value = ``;
    sheet.getCell('I14').value = accom?.confirm_file?.url ? accom?.confirm_file?.url : '-';
    sheet.getCell('I15').value = ``;

    for (let i=11; i<16; i++){
     sheet.mergeCells(`I${i}:K${i}`);
   }

    sheet.getCell('B16').value = '';


    /* Flight info */

    sheet.mergeCells(`B17:C17`);
    sheet.getCell('B17').value = 'Flight Info';

    sheet.getCell('B18').value = `Arrival: ${group?.arrival_date ? moment(group?.arrival_date).format('YYYY-MM-DD ddd') : '-'} ${estTimeArr?`est.:${estTimeArr}`:''}`;
    sheet.getCell('B19').value = `Flight no.: ${group?.arrival_flight?.name ? group?.arrival_flight?.name : '-'}`;

    for (let i=18; i<20; i++){
      sheet.mergeCells(`B${i}:C${i}`);
    }

    sheet.getCell('D18').value = `Departure: ${group?.departure_date ? moment(group?.departure_date).format('YYYY-MM-DD ddd') : '-'} ${estTimeDep?`est.:${estTimeDep}`:''}`;
    sheet.getCell('D19').value = `Flight no.: ${group?.departure_flight?.name ? group?.departure_flight?.name : '-'}`;

    for (let i=18; i<20; i++){
      sheet.mergeCells(`D${i}:H${i}`);
    }

    sheet.getCell('B20').value = '';
    sheet.mergeCells(`B21:C21`);
    sheet.getCell('B21').value = 'Activities';

    /* Accommodations */

    sheet.eachRow(function (row, rowNum) {
      row.eachCell(function (cell, cellNum) {

        cell.alignment = {
          vertical: 'middle',
          wrapText: true,
        };

        if (cell?.row > 21){
          if (cell._column.key === 'meeting_time' || cell._column.key === 'pickup_time' || cell._column.key === 'address_from') {
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'F3F3F3' },
            };
          }

          if (cell._column.key === 'address_to' || cell._column.key === 'start_time') {
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'D9D9D9' },
            };
          }
        }

        if (cell?.row > 21) {

          if (
            cell._column._key === 'start_time' ||
            cell._column._key === 'pickup_time' ||
            cell._column._key === 'meeting_time' ||
            cell._column._key === 'group_size'
          ) {
            cell.alignment = {
              vertical: 'middle',
              horizontal: 'center',
              wrapText: true,
            };
          }
        }
      });
    });

    const guideNames = group?.guides.map(getName);

    const createOuterBorder1 = (worksheet, start, end) => {
      // Bal oszlop (függőleges bal szegély)
      for (let row = start.row; row <= end.row; row++) {

        const cell = worksheet.getCell(row, start.col);
        cell.border = {
          ...cell.border, // Megtartja a meglévő szegélyeket
          left: { style: 'thin', color: { argb: '000000' } }, // Jobb szegély hozzáadása
        };
      }

      // Jobb oszlop (függőleges jobb szegély)
      for (let row = start.row; row <= end.row; row++) {

        const cell = worksheet.getCell(row, end.col);
        cell.border = {
          ...cell.border, // Megtartja a meglévő szegélyeket
          right: { style: 'thin', color: { argb: '000000' } }, // Jobb szegély hozzáadása
        };

      }

      // Felső sor (vízszintes felső szegély)
      for (let col = start.col; col <= end.col; col++) {

        const cell = worksheet.getCell(start.row, col);
        cell.border = {
          ...cell.border, // Megtartja a meglévő szegélyeket
          top: { style: 'thin', color: { argb: '000000' } }, // Jobb szegély hozzáadása
        };

      }

      // Alsó sor (vízszintes alsó szegély)
      for (let col = start.col; col <= end.col; col++) {

        const cell = worksheet.getCell(end.row, col);
        cell.border = {
          ...cell.border, // Megtartja a meglévő szegélyeket
          bottom: { style: 'thin', color: { argb: '000000' } }, // Jobb szegély hozzáadása
        };

      }

    };

    createOuterBorder1(sheet, { row: 4, col: 2 }, { row: 8, col: 11 });
    createOuterBorder1(sheet, { row: 11, col: 2 }, { row: 15, col: 11 });
    createOuterBorder1(sheet, { row: 18, col: 2 }, { row: 19, col: 11 });

    for (let i=1; i<100; i++){
      sheet.getRow(i).font = {
        name: 'Roboto',
        family: 4,
        size: defaultSize,
      }
    }

    //Headers
    sheet.getCell('B1').font = {
      name: 'Roboto',
      family: 4,
      size: 14,
      bold: true,
    };
    sheet.getCell('B3').font = {
      name: 'Roboto',
      family: 4,
      size: defaultSize,
      bold: true,
    };
    sheet.getCell('B10').font = {
      name: 'Roboto',
      family: 4,
      size: defaultSize,
      bold: true,
    };
    sheet.getCell('B17').font = {
      name: 'Roboto',
      family: 4,
      size: defaultSize,
      bold: true,
    };
    sheet.getCell('B21').font = {
      name: 'Roboto',
      family: 4,
      size: defaultSize,
      bold: true,
    };

    const mergedCells = {};
    sheet.eachRow((row) => {
      row.eachCell((cell) => {
        const merge = sheet._merges[cell.address]; // Ellenőrizzük, hogy a cella egy merge része-e
        if (merge) {
          const mergeRange = merge.model; // Merge tartomány modellje

          // Bejárjuk az egyesített tartomány összes celláját
          for (let rowNum = mergeRange.top; rowNum <= mergeRange.bottom; rowNum++) {
            for (let colNum = mergeRange.left; colNum <= mergeRange.right; colNum++) {
              const cellName = `${String.fromCharCode(64 + colNum)}${rowNum}`; // Cellanév például "A1"
              mergedCells[cellName] = true; // Hozzáadjuk az egyesített cellák listájához
            }
          }
        }
      });
    });

    sheet.eachRow((row) => {
      let maxLines = 1;

      if (row._number>22){
        row.eachCell((cell) => {
          if (cell.value && typeof cell.value === 'string') {
            const lineCount = Math.ceil(cell.value.length / cell._column.width);
            maxLines = Math.max(maxLines, lineCount);
          }
        });
        row.height = maxLines * 12;
      }

      if (row._number < 22) {
        let maxLines = 1;
        const processedCells = new Set(); // Nyomon követjük a már feldolgozott cellákat

        row.eachCell((cell) => {

          const merge = sheet._merges[cell.address];
          if (merge) {
            const range = merge.model;
            const masterCell = `${range.top}:${range.left}`;

            if (processedCells.has(masterCell)) {
              return;
            }
            processedCells.add(masterCell);

            let totalWidth = 0;
            for (let i = range.left; i <= range.right; i++) {
              totalWidth += sheet.getColumn(i).width || 10;
            }

            if (cell.value && typeof cell.value === 'string') {
              const lineCount = Math.ceil(cell.value.length / totalWidth);
              maxLines = Math.max(maxLines, lineCount);
            }
          }/*else{

            if (cell.value && typeof cell.value === 'string') {
              if (!mergedCells[cell._address]){
                const lineCount = Math.ceil(cell.value.length / cell._column.width);
                maxLines = Math.max(maxLines, lineCount);
              }
            }
          }*/
        });

        row.height = maxLines * 12;
      }

    });

    sheet.getRow(15).height=24;
    sheet.getRow(22).eachCell(function (cell, cellNum) {
      cell.font = {
        name: 'Roboto',
        family: 4,
        size: defaultSize,
        bold: true,
      };
    });

    promise.then(() => {
      workbook.xlsx.writeBuffer().then(function (data) {
        const blob = new Blob([data], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = window.URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = `${group?.name}-${guideNames.join('-')}-${
          group?.arrival_date
        }.xlsx`;
        anchor.click();
        window.URL.revokeObjectURL(url);
      });
    });
  };

  return (
    <>

      {listItem ? (
        <>
          <ListItemButton
            disabled={loading}
            onClick={(event) => {
              generateSchedule();
            }}
          >
            <ListItemIcon>
              <CloudDownloadRoundedIcon color={'primary'}/>
            </ListItemIcon>
            <ListItemText>Guide Schedule</ListItemText>
          </ListItemButton>
        </>
      ) : (

        <LoadingButton
          onClick={() => {
            generateSchedule();
          }}
          loading={loading}
          variant="contained"
          disabled={loading}
        >
          Guide Schedule
        </LoadingButton>
      )}

    </>
  );
};
